<template>
  <v-toolbar v-if="this.navs && this.navs.length > 0" dense style="background-color: #114b5f; color: white">
    <!-- <v-toolbar-items>
      <Menulink
        v-for="(nav, index) in this.navs"
        :linkname="nav.to"
        :key="index"
        :texto="nav.texto"
        @linkclickeado="drawer = false"
      ></Menulink>
    </v-toolbar-items> -->
    <v-toolbar-items >
      <v-menu
        bottom
        left
        v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark icon v-bind="attrs" v-on="on" color="black">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>
        <Menulink
          v-for="(nav, index) in this.navs"
          :linkname="nav.to"
          :key="index"
          :texto="nav.texto"
          @linkclickeado="drawer = false"
        ></Menulink>
      </v-menu>
      <template v-else>
        <Menulink
          v-for="(nav, index) in this.navs"
          :linkname="nav.to"
          :key="index"
          :texto="nav.texto"
          @linkclickeado="drawer = false"
        ></Menulink>
      </template>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapGetters } from 'vuex'
import Menulink from '@/components/MenuLink'
export default {
  components: {
    Menulink
  },
  data() {
    return {
      navs: []
    }
  },
  watch: {
    $route(to, from) {
      this.getNavigation()
    }
  },
  computed: {
    ...mapGetters('comun', ['getNavs'])
  },
  methods: {
    getNavigation() {
      let q = this.$route.path.split('/')[1]
      this.navs = this.getNavs(q)
    }
  },
  mounted() {
    this.getNavigation()
  }
}
</script>

<style></style>
